<script setup lang="ts">
import { router } from "../router";
import { adminDataSetup, isSelfAdmin } from "../states/adminsState";
import { selfApproved } from "../states/approveSelfEnterState";
import { finishState, goFinish } from "../states/finishState";
import { roomState, updateLocalRoom } from "../states/room";
import { roomStarted } from "../states/viewState";
import { ws_instance } from "../websocket/ws-instance";
import ActiveRoomNew from "./room/ActiveRoomNew.vue";
import AdminSettingRoom from "./room/AdminSettingRoom.vue";
import FinishPage from "./room/FinishPage.vue";
import UserSettingRoom from "./room/UserSettingRoom.vue";
const props = defineProps<{
  roomId: string;
}>();
async function init() {
  await ws_instance.connect(props.roomId);
  await adminDataSetup(props.roomId).catch((err) => {
    router.replace({
      name: "error",
      params: {
        errtype: "bad-query",
      },
    });
    throw err;
  });
  if (!roomState.id) {
    await updateLocalRoom(props.roomId)
      .then((room) => {
        if (room.status === "Created" || room.status === "Suspended") {
          const exp = new Date(room.expireTime);
          if (exp.getTime() < Date.now()) {
            router.replace({
              name: "error",
              params: {
                errtype: "link-expired",
              },
            });
          }
        }
      })
      .catch((err?: { data?: { message?: string; roomName: string } }) => {
        if (err?.data?.message === "you kicked") {
          roomState.name = err?.data?.roomName;
          goFinish("kick");
        } else if (err?.data?.message === "you not participant") {
          router.push({
            name: "error",
            params: {
              errtype: "not-participant",
            },
          });
        } else {
          router.push({
            name: "error",
            params: {
              errtype: "bad-query",
            },
          });
        }
      });
  }
}
init();
</script>
<template>
  <FinishPage v-if="finishState.finished && !finishState.fixReload" />
  <ActiveRoomNew
    v-else-if="
      (roomState.status === 'Active' && roomStarted && selfApproved) ||
      finishState.fixReload
    "
  />
  <AdminSettingRoom
    v-else-if="
      roomState.id !== '' &&
      isSelfAdmin &&
      ['Created', 'Suspended', 'Active'].includes(roomState.status)
    "
  />
  <UserSettingRoom v-else-if="roomState.id !== ''" />
</template>
<style scoped></style>
